import { render, staticRenderFns } from "./PmwSelectedItem.vue?vue&type=template&id=deb58350&scoped=true&"
import script from "./PmwSelectedItem.vue?vue&type=script&lang=js&"
export * from "./PmwSelectedItem.vue?vue&type=script&lang=js&"
import style0 from "./PmwSelectedItem.vue?vue&type=style&index=0&id=deb58350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb58350",
  null
  
)

export default component.exports